import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f0495fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-blurred-upload" }
const _hoisted_2 = {
  key: 0,
  class: "invoice-blurred-upload__banner is-orange"
}
const _hoisted_3 = {
  key: 1,
  class: "invoice-blurred-upload__banner is-orange"
}
const _hoisted_4 = {
  key: 2,
  class: "invoice-blurred-upload__banner is-orange"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-blurred-upload__section-title" }, "开票数据", -1))
const _hoisted_6 = { class: "invoice-blurred-upload__category-header" }
const _hoisted_7 = { class: "invoice-blurred-upload__category-summary" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "1", -1))
const _hoisted_9 = { style: {"color":"var(--xrk-color-primary)"} }
const _hoisted_10 = { class: "invoice-blurred-upload__count" }
const _hoisted_11 = {
  key: 4,
  class: "invoice-blurred-upload__section-title"
}
const _hoisted_12 = {
  key: 5,
  class: "invoice-blurred-upload__banner is-orange",
  style: {"display":"flex","flex-direction":"column","gap":"4px","margin-bottom":"12px"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "invoice-blurred-upload__list" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-blurred-upload__section-title" }, "发票-蓝票", -1))
const _hoisted_17 = {
  key: 0,
  class: "invoice-blurred-upload__badge is-blue"
}
const _hoisted_18 = {
  key: 1,
  class: "invoice-blurred-upload__badge is-green"
}
const _hoisted_19 = { class: "invoice-blurred-upload__blue" }
const _hoisted_20 = { class: "invoice-blurred-upload__fields" }
const _hoisted_21 = {
  key: 0,
  class: "ocr-tip is-loading"
}
const _hoisted_22 = {
  key: 1,
  class: "ocr-tip is-done"
}
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票日期", -1))
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "票面金额", -1))
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票号码", -1))
const _hoisted_29 = {
  key: 2,
  class: "invoice-blurred-upload__red"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-blurred-upload__section-title" }, "发票-红票", -1))
const _hoisted_31 = {
  key: 0,
  class: "invoice-blurred-upload__red-list"
}
const _hoisted_32 = {
  key: 0,
  class: "invoice-blurred-upload__badge is-orange"
}
const _hoisted_33 = {
  key: 1,
  class: "invoice-blurred-upload__badge is-green"
}
const _hoisted_34 = { class: "invoice-blurred-upload__fields" }
const _hoisted_35 = {
  key: 0,
  class: "ocr-tip is-loading"
}
const _hoisted_36 = {
  key: 1,
  class: "ocr-tip is-done"
}
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票日期", -1))
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "票面金额（负）", -1))
const _hoisted_41 = { class: "field" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票号码", -1))
const _hoisted_43 = {
  key: 0,
  class: "invoice-blurred-upload__adder"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-blurred-upload__section-title" }, "申请冲红", -1))
const _hoisted_45 = { class: "invoice-blurred-upload__red-amount" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "冲红金额", -1))
const _hoisted_47 = { class: "tip" }
const _hoisted_48 = { class: "invoice-blurred-upload__section-title" }
const _hoisted_49 = {
  key: 0,
  class: "invoice-blurred-upload__badge-inline is-grey"
}
const _hoisted_50 = { class: "invoice-blurred-upload__section-title" }
const _hoisted_51 = {
  key: 0,
  class: "invoice-blurred-upload__badge-inline is-grey"
}
const _hoisted_52 = {
  key: 9,
  class: "invoice-blurred-upload__summary"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { style: {"color":"#e6a23c"} }
const _hoisted_55 = { key: 1 }

import { computed, watch, ref } from 'vue';
import BigNumber from 'bignumber.js';
import {
  BaseUpload,
  BaseImage,
  BaseInput,
  BaseInputNumber,
  BaseIcon,
  BaseCard,
  XrkMessage
} from 'xrk-components';
import { DeleteFilled } from '@element-plus/icons-vue';
import { uploadApi } from '@data-source/common/apis';
import {
  GtBlueRedInvoiceItem,
  GtInvoiceDetailData,
  GtFileGroup,
  InvoiceApplyDetailImgDTO
} from '@V/invoice/src/data-source/types';
import type { GtButtonSource } from '@V/invoice/src/types';
import { recognition } from '@V/invoice/src/data-source/apis';
import { formatter } from '@/utils';

type FileDTO = NonNullable<GtFileGroup['blueFileList']>[number];


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-blurred-upload',
  props: /*#__PURE__*/_mergeModels({
    buttonSource: { default: 1 },
    id: { default: null }
  }, {
    "formData": {
  default: () => ({
    blueRedInvoiceList: [],
    fileGroup: { blueFileList: [], redFileList: [] },
    info: {} as GtInvoiceDetailData['info']
  })
},
    "formDataModifiers": {},
    "redAmount": { default: 0 },
    "redAmountModifiers": {},
  }),
  emits: ["update:formData", "update:redAmount"],
  setup(__props: any, { expose: __expose }) {

const props = __props;

// 双向绑定开票数据（蓝红票 / 类目 / 附件 / info），便于增删改回写父级
const formData = _useModel<GtInvoiceDetailData>(__props, 'formData');

// 申请冲红金额（元；8/9/10 时可编辑）
const redAmount = _useModel<number>(__props, 'redAmount');

/* ---------------- formData 子字段视图 ---------------- */
const list = computed(() => formData.value.blueRedInvoiceList || []);
const itemDetailList = computed(
  () => formData.value.info?.itemDetailList || []
);

/* ---------------- 其他材料：DTO ↔ BaseUpload 格式双向映射 ---------------- */
const toUpload = (dto: FileDTO) => ({
  fileUrl: dto.fileUrl,
  fileName: dto.fileName,
  name: dto.fileName,
  url: dto.fileUrl
});

const dtoListFrom = (
  uploads: any[],
  existingDTOs: FileDTO[],
  invoiceType: 1 | 2
): FileDTO[] =>
  uploads.map((u, i) => ({
    id: existingDTOs[i]?.id,
    invoiceApplyId: existingDTOs[i]?.invoiceApplyId || props.id,
    fileUrl: (u.fileUrl || u.url || '') as string,
    fileName: (u.fileName || u.name || '') as string,
    invoiceType,
    name: (u.fileName || u.name || '') as string,
    createAt: existingDTOs[i]?.createAt || Date.now(),
    remark: existingDTOs[i]?.remark,
    url: (u.fileUrl || u.url || '') as string,
    uid: existingDTOs[i]?.uid || Date.now(),
    status: existingDTOs[i]?.status
  }));

const blueOtherFiles = ref<any[]>([]);
const redOtherFiles = ref<any[]>([]);

watch(
  () => formData.value.fileGroup,
  fg => {
    if (fg?.blueFileList) {
      blueOtherFiles.value = fg.blueFileList.map(toUpload);
    }
    if (fg?.redFileList) {
      redOtherFiles.value = fg.redFileList.map(toUpload);
    }
  },
  { immediate: true }
);

watch(
  blueOtherFiles,
  v => {
    if (!formData.value.fileGroup)
      formData.value.fileGroup = { blueFileList: [], redFileList: [] };
    formData.value.fileGroup.blueFileList = dtoListFrom(
      v,
      formData.value.fileGroup?.blueFileList || [],
      1
    ) as any;
  },
  { deep: true }
);

watch(
  redOtherFiles,
  v => {
    if (!formData.value.fileGroup)
      formData.value.fileGroup = { blueFileList: [], redFileList: [] };
    formData.value.fileGroup.redFileList = dtoListFrom(
      v,
      formData.value.fileGroup?.redFileList || [],
      2
    );
  },
  { deep: true }
);
const info = computed(() => formData.value.info);

/* ---------------- 模式派生状态（直接基于 GtButtonSource） ---------------- */
/** 可编辑模式：1~5、补充红票 15；审核 6/7、冲红 8/9/10、详情 11 全部只读 */
const isEditMode = computed(() =>
  [1, 2, 3, 4, 5, 15].includes(props.buttonSource)
);
const isUploadBlue = computed(() => props.buttonSource === 1);
const isSupplement = computed(() => props.buttonSource === 2);
const isModifyBlue = computed(() => props.buttonSource === 3);
const isModifyRed = computed(() => props.buttonSource === 5);
/** 补充红票：部分冲红后追加新红票，蓝票/已有红票只读 */
const isSupplementRed = computed(() => props.buttonSource === 15);
const isReject = computed(() => isModifyBlue.value || isModifyRed.value);
/** 操作蓝票（上传/修改/补传） */
const isBlueOpMode = computed(
  () => isUploadBlue.value || isModifyBlue.value || isSupplement.value
);
/** 上传/修改红票 */
const isRedMode = computed(
  () => props.buttonSource === 4 || props.buttonSource === 5
);
/** 申请/重申/继续冲红 */
const isRedApplyMode = computed(() => [8, 9, 10].includes(props.buttonSource));

// 新增按钮：蓝票/红票操作模式本身即属可编辑模式，无需再判断 isEditMode
// 补充红票（15）只追加红票，蓝票区不可新增
const canAddBlue = computed(() => isBlueOpMode.value);
const canAddRed = computed(() => isRedMode.value || isSupplementRed.value);

/* ---------------- 锁定与可编辑判断 ---------------- */
/**
 * 锁定来源：blueInvoice.nowAuditStatus === 2 表示审核通过不可编辑
 */
const isAuditLocked = (item: GtBlueRedInvoiceItem) =>
  item.blueInvoice?.nowAuditStatus === 2;

/** 补传模式下原已开票卡片锁定（蓝色 badge） */
const isOriginLocked = (item: GtBlueRedInvoiceItem) =>
  isSupplement.value && !item._isNew;

const isCardLocked = (item: GtBlueRedInvoiceItem) =>
  isAuditLocked(item) || isOriginLocked(item);

/** 当前组中的红票审核通过 */
const isRedNowAuditStatus2 = (red: InvoiceApplyDetailImgDTO) =>
  red.nowAuditStatus === 2;
/** 红票自身是否锁定：自身 nowAuditStatus === 2，或补充红票模式下的原有红票 */
const isRedLocked = (red: InvoiceApplyDetailImgDTO) =>
  isRedNowAuditStatus2(red) || (isSupplementRed.value && !red._isNew);

/** 蓝票字段是否可编辑：先看是否可编辑模式，再看本卡 nowAuditStatus 锁定 */
const canEditBlue = (item: GtBlueRedInvoiceItem) => {
  if (!isEditMode.value || isCardLocked(item)) return false;
  // 补充红票（15）蓝票全部只读
  if (isSupplementRed.value) return false;
  if (isSupplement.value) return !!item._isNew;
  return isUploadBlue.value || isModifyBlue.value;
};

/** 红票字段是否可编辑：先看是否可编辑模式，再看父卡 / 红票自身 nowAuditStatus 锁定 */
const canEditRed = (
  item: GtBlueRedInvoiceItem,
  red: InvoiceApplyDetailImgDTO
) => {
  if (!isEditMode.value || isRedLocked(red)) return false;
  return isRedMode.value || isSupplementRed.value;
};

/** 是否展示某蓝票下的红票区 */
const showRedSection = (item: GtBlueRedInvoiceItem) => {
  if (isRedMode.value || isSupplementRed.value) {
    return true;
  }
  return (item.redInvoiceList || []).length > 0;
};

/* ---------------- 其他材料区可见/可编辑（操作谁谁可编辑） ---------------- */
const canEditOtherBlue = computed(() => isBlueOpMode.value);
const canEditOtherRed = computed(
  () => isRedMode.value || isSupplementRed.value
);

const canShowOtherBlue = computed(() => {
  if (canEditOtherBlue.value) return true;
  return blueOtherFiles.value.length > 0;
});
const canShowOtherRed = computed(() => {
  if (canEditOtherRed.value) return true;
  return redOtherFiles.value.length > 0;
});

/* ---------------- 计数与汇总 ---------------- */
const blueCount = computed(
  () => list.value.filter(i => i.blueInvoice?.invoicePic).length
);
const originBlueCount = computed(
  () => list.value.filter(i => i.blueInvoice?.invoicePic && !i._isNew).length
);
const newBlueCount = computed(() => list.value.filter(i => i._isNew).length);

/** 冲红金额上限（元）：info.maximumCreditableAmount 已由数据源层转元 */
const maxRedAmount = computed(
  () => Number(info.value.maximumCreditableAmount) || 0
);

/** 金额求和（元，bignumber.js，保留两位小数）；金额已由数据源层转元 */
const sumYuan = (nums: Array<number | null | undefined>) =>
  nums
    .reduce(
      (acc: BigNumber, n) => acc.plus(new BigNumber(n || 0)),
      new BigNumber(0)
    )
    .toFixed(2);

/** 蓝票票面金额合计（元，前端展示） */
const totalBlueAmountYuan = computed(() =>
  sumYuan(list.value.map(i => i.blueInvoice?.invoiceAmount))
);

/* ---------------- OCR ---------------- */
const runOcr = async (
  fileUrl: string
): Promise<Partial<InvoiceApplyDetailImgDTO>> => {
  try {
    const { data } = await recognition({ paramURL: fileUrl });
    // OCR amountInFiguers 为「元」字符串，bignumber.js 解析为数值（禁止 parseFloat）
    const ocrAmount = new BigNumber(data.amountInFiguers);
    return {
      invoiceDate: data.invoiceDate,
      invoiceAmount: ocrAmount.isNaN() ? 0 : ocrAmount.dp(2).toNumber(),
      invoiceNo: data.invoiceNumConfirm,
      purchaserName: data.purchaserName,
      purchaserRegisterNum: data.purchaserRegisterNum,
      sellerName: data.sellerName,
      sellerRegisterNum: data.sellerRegisterNum
    };
  } catch {
    return {};
  }
};

const createImg = (
  fileUrl: string,
  invoiceType: 1 | 2
): InvoiceApplyDetailImgDTO => ({
  invoiceApplyId: props.id,
  invoicePic: fileUrl,
  invoiceNo: '',
  invoiceAmount: null,
  invoiceDate: '',
  invoiceType,
  createAt: Date.now(),
  purchaserName: '',
  purchaserRegisterNum: '',
  sellerName: '',
  sellerRegisterNum: '',
  nowAuditStatus: 0,
  _isNew: true,
  _ocrLoading: true,
  _ocrDone: false
});

/* ---------------- 蓝票上传 / 删除 ---------------- */
// 校验上传结果结构、失败回滚、与父级提交逻辑对接
const onBlueUpload = async (v: any) => {
  const fileUrl = v?.response?.data?.fileUrl;
  if (!fileUrl) return;
  const item: GtBlueRedInvoiceItem = {
    blueInvoice: createImg(fileUrl, 1),
    redAmount: 0,
    redInvoiceList: [],
    _isNew: true
  };
  const ocr = await runOcr(fileUrl);
  Object.assign(item.blueInvoice, ocr, { _ocrLoading: false, _ocrDone: true });
  formData.value.blueRedInvoiceList.push(item);
};

// 删除时同步父级 / 后端删除标记
const onBlueRemove = (index: number) => {
  formData.value.blueRedInvoiceList.splice(index, 1);
};

/* ---------------- 红票上传 / 删除 ---------------- */
// 校验冲红金额不超过票面、红票金额聚合等业务规则
const onRedUpload = async (item: GtBlueRedInvoiceItem, v: any) => {
  const fileUrl = v?.response?.data?.fileUrl;
  if (!fileUrl) return;
  const red = createImg(fileUrl, 2);
  if (!item.redInvoiceList) item.redInvoiceList = [];
  const ocr = await runOcr(fileUrl);
  Object.assign(red, ocr, { _ocrLoading: false, _ocrDone: true });
  item.redInvoiceList.push(red);
};

// 删除时同步父级 / 后端删除标记
const onRedRemove = (item: GtBlueRedInvoiceItem, index: number) => {
  item.redInvoiceList.splice(index, 1);
};

/* ---------------- 文件预览 ---------------- */
const onFilePreview = (v: any) => {
  if (v?.url) window.open(v.url);
};

/* ---------------- 校验（暴露给父组件） ---------------- */
// 实际校验规则已与后端对齐，根据模式做最小化合法性校验
const validate = () => {
  const reject = (msg: string) => {
    XrkMessage.error(msg);
    return Promise.reject(new Error(msg));
  };
  if (isUploadBlue.value || isModifyBlue.value) {
    if (!list.value.length) return reject('请上传蓝票');
    for (const it of list.value) {
      if (isCardLocked(it)) continue;
      if (!it.blueInvoice?.invoicePic) {
        return reject('请上传蓝票照片');
      }
      if (!it.blueInvoice.invoiceAmount || !it.blueInvoice.invoiceNo) {
        return reject('请填写蓝票信息');
      }
    }
  }

  if (isSupplement.value) {
    const newOnes = list.value.filter(i => i._isNew);
    if (!newOnes.length) {
      return reject('请追加至少一张蓝票');
    }
    for (const it of newOnes) {
      if (!it.blueInvoice?.invoicePic) {
        return reject('请上传蓝票照片');
      }
      if (!it.blueInvoice.invoiceAmount || !it.blueInvoice.invoiceNo) {
        return reject('请填写蓝票信息');
      }
    }
  }

  if (isRedApplyMode.value) {
    if (!redAmount.value || redAmount.value <= 0) {
      return reject('请填写冲红金额');
    }
  }

  if (isRedMode.value || isSupplementRed.value) {
    const flat = list.value.flatMap(i => i.redInvoiceList || []);
    // 补充红票需追加新红票；上传/修改红票要求整体存在红票
    const pending = isSupplementRed.value ? flat.filter(r => r._isNew) : flat;
    if (!pending.length) {
      return reject(
        isSupplementRed.value ? '请追加至少一张红票' : '请上传红票'
      );
    }
    for (const r of pending) {
      if (isRedLocked(r)) continue;
      if (!r.invoicePic) {
        return reject('请上传红票照片');
      }
      if (!r.invoiceAmount || !r.invoiceNo) {
        return reject('请填写红票信息');
      }
    }
  }

  return Promise.resolve();
};

__expose({ validate });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isReject.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 审核驳回，请根据要求修改" + _toDisplayString(isModifyRed.value ? '红票' : '蓝票') + "信息后重新提交 ", 1))
      : (isSupplement.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 请补传发票材料，原已开票记录不可修改 "))
        : (isSupplementRed.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 请补传红票材料，蓝票及已有红票不可修改 "))
          : _createCommentVNode("", true),
    (itemDetailList.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemDetailList.value, (group, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.itemId,
              class: "invoice-blurred-upload__category"
            }, [
              _createElementVNode("div", _hoisted_6, " 开票类目 " + _toDisplayString(idx + 1) + "：" + _toDisplayString(group.itemName || '-'), 1),
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" 共 "),
                _hoisted_8,
                _createTextVNode(" 条， 金额合计： "),
                _createElementVNode("b", _hoisted_9, " ¥" + _toDisplayString(_unref(formatter).fen2yuan(group.invoiceSettlementSummaryAmount)), 1)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(" 已添加 "),
            _createElementVNode("b", null, _toDisplayString(blueCount.value), 1),
            _createTextVNode(" 张蓝票 ")
          ])
        ], 64))
      : _createCommentVNode("", true),
    (info.value.redReason || info.value.maximumCreditableAmount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 红冲信息 "))
      : _createCommentVNode("", true),
    (info.value.redReason || info.value.maximumCreditableAmount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (info.value.redReason)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "冲红原因：" + _toDisplayString(info.value.redReason), 1))
            : _createCommentVNode("", true),
          (info.value.redAmount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createTextVNode(" 申请红冲金额： "),
                _createElementVNode("b", null, "¥" + _toDisplayString(info.value.redAmount), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return (_openBlock(), _createBlock(_unref(BaseCard), {
          key: item.blueInvoice?.id ?? index,
          class: "invoice-blurred-upload__card"
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            (isOriginLocked(item))
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " 已开票 "))
              : (isAuditLocked(item))
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 已通过 "))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (item.blueInvoice?.invoicePic)
                ? (_openBlock(), _createBlock(_unref(BaseImage), {
                    key: 0,
                    class: "invoice-blurred-upload__img",
                    src: item.blueInvoice.invoicePic,
                    "preview-src-list": [item.blueInvoice.invoicePic]
                  }, null, 8, ["src", "preview-src-list"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                (item.blueInvoice?._ocrLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 识别中..." + _toDisplayString(item.blueInvoice?._ocrDone), 1))
                  : (item.blueInvoice?._ocrDone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, " ✓ OCR已识别，请核对，可手动修改 "))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_unref(BaseInput), {
                    modelValue: item.blueInvoice.invoiceDate,
                    "onUpdate:modelValue": ($event: any) => ((item.blueInvoice.invoiceDate) = $event),
                    placeholder: "请输入",
                    disabled: !canEditBlue(item)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_unref(BaseInputNumber), {
                    modelValue: item.blueInvoice.invoiceAmount,
                    "onUpdate:modelValue": ($event: any) => ((item.blueInvoice.invoiceAmount) = $event),
                    placeholder: "请输入",
                    controls: false,
                    precision: 2,
                    min: 0,
                    max: 999999999,
                    disabled: !canEditBlue(item)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_unref(BaseInput), {
                    modelValue: item.blueInvoice.invoiceNo,
                    "onUpdate:modelValue": ($event: any) => ((item.blueInvoice.invoiceNo) = $event),
                    placeholder: "请输入",
                    disabled: !canEditBlue(item)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                (canEditBlue(item) && item.blueInvoice?.invoicePic)
                  ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                      key: 2,
                      class: "invoice-blurred-upload__remove",
                      size: "18",
                      color: "#ED7067",
                      onClick: ($event: any) => (onBlueRemove(index))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DeleteFilled))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (showRedSection(item))
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  ((item.redInvoiceList || []).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.redInvoiceList, (red, rIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: red.id ?? rIndex,
                            class: _normalizeClass(["invoice-blurred-upload__red-card", { 'is-locked': isRedLocked(red) }])
                          }, [
                            ((isModifyRed.value || isSupplementRed.value) && !red._isNew)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(isSupplementRed.value ? '已冲红' : '原红票'), 1))
                              : (isRedNowAuditStatus2(red))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, " 已通过 "))
                                : _createCommentVNode("", true),
                            (red.invoicePic)
                              ? (_openBlock(), _createBlock(_unref(BaseImage), {
                                  key: 2,
                                  class: "invoice-blurred-upload__img",
                                  src: red.invoicePic,
                                  "preview-src-list": [red.invoicePic]
                                }, null, 8, ["src", "preview-src-list"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_34, [
                              (red._ocrLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 识别中... "))
                                : (red._ocrDone)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, " ✓ OCR已识别，请核对，可手动修改 "))
                                  : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createVNode(_unref(BaseInput), {
                                  modelValue: red.invoiceDate,
                                  "onUpdate:modelValue": ($event: any) => ((red.invoiceDate) = $event),
                                  placeholder: "请输入开票日期",
                                  disabled: !canEditRed(item, red)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createVNode(_unref(BaseInputNumber), {
                                  modelValue: red.invoiceAmount,
                                  "onUpdate:modelValue": ($event: any) => ((red.invoiceAmount) = $event),
                                  placeholder: "请输入",
                                  controls: false,
                                  precision: 2,
                                  min: 0,
                                  max: 999999999,
                                  disabled: !canEditRed(item, red)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createVNode(_unref(BaseInput), {
                                  modelValue: red.invoiceNo,
                                  "onUpdate:modelValue": ($event: any) => ((red.invoiceNo) = $event),
                                  placeholder: "请输入",
                                  disabled: !canEditRed(item, red)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              (canEditRed(item, red))
                                ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                                    key: 2,
                                    class: "invoice-blurred-upload__remove",
                                    size: "18",
                                    color: "#ED7067",
                                    onClick: ($event: any) => (onRedRemove(item, rIndex))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(DeleteFilled))
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (canAddRed.value)
                    ? (_openBlock(), _createBlock(_unref(BaseUpload), {
                        key: 1,
                        autoUpload: "",
                        btnText: "+添加红票",
                        tipText: "只能上传jpg/png，且每份不超过50MB",
                        listType: null,
                        accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                        limit: 20,
                        limitSize: 50,
                        multiple: false,
                        showFileList: false,
                        "http-request": _unref(uploadApi),
                        onChange: v => onRedUpload(item, v)
                      }, null, 8, ["http-request", "onChange"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (canAddBlue.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createVNode(_unref(BaseUpload), {
              autoUpload: "",
              btnText: "+添加蓝票",
              tipText: "只能上传jpg/png，且每份不超过50MB",
              listType: null,
              accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
              limit: 20,
              limitSize: 50,
              multiple: false,
              showFileList: false,
              "http-request": _unref(uploadApi),
              onChange: onBlueUpload
            }, null, 8, ["http-request"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (isRedApplyMode.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createVNode(_unref(BaseInputNumber), {
              modelValue: redAmount.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((redAmount).value = $event)),
              style: {"width":"240px"},
              placeholder: "请输入",
              controls: false,
              precision: 2,
              step: 0.01,
              min: 0,
              max: maxRedAmount.value
            }, null, 8, ["modelValue", "max"]),
            _createElementVNode("span", _hoisted_47, [
              _createTextVNode(" 申请红冲金额上限： "),
              _createElementVNode("b", null, "¥" + _toDisplayString(maxRedAmount.value.toFixed(2)), 1)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (canShowOtherBlue.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
          _createElementVNode("div", _hoisted_48, [
            _createTextVNode(" 其他材料（蓝票） "),
            (!canEditOtherBlue.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_49, " 仅查看 "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(BaseUpload), {
            listType: "text",
            autoUpload: "",
            showFileList: "",
            btnText: "添加文件",
            tipText: 
          canEditOtherBlue.value
            ? '只能上传png/jpg/jpeg/pdf/bmp文件，且每份不超过50MB'
            : ''
        ,
            accept: ['.jpg', '.jpeg', '.png', '.pdf', '.bmp'],
            limit: canEditOtherBlue.value ? 10 : 0,
            limitSize: 50,
            multiple: false,
            "http-request": _unref(uploadApi),
            disabled: !canEditOtherBlue.value,
            uploadBtnProps: { limitOverHide: true },
            fileList: blueOtherFiles.value,
            "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((blueOtherFiles).value = $event)),
            onPreview: onFilePreview
          }, null, 8, ["tipText", "limit", "http-request", "disabled", "fileList"])
        ], 64))
      : _createCommentVNode("", true),
    (canShowOtherRed.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
          _createElementVNode("div", _hoisted_50, [
            _createTextVNode(" 其他材料（红票） "),
            (!canEditOtherRed.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_51, " 仅查看 "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(BaseUpload), {
            listType: "text",
            autoUpload: "",
            showFileList: "",
            btnText: "添加文件",
            tipText: 
          canEditOtherRed.value
            ? '只能上传png/jpg/jpeg/pdf/bmp文件，且每份不超过50MB'
            : ''
        ,
            accept: ['.jpg', '.jpeg', '.png', '.pdf', '.bmp'],
            limit: canEditOtherRed.value ? 10 : 0,
            limitSize: 50,
            multiple: false,
            "http-request": _unref(uploadApi),
            disabled: !canEditOtherRed.value,
            uploadBtnProps: { limitOverHide: true },
            fileList: redOtherFiles.value,
            "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((redOtherFiles).value = $event)),
            onPreview: onFilePreview
          }, null, 8, ["tipText", "limit", "http-request", "disabled", "fileList"])
        ], 64))
      : _createCommentVNode("", true),
    (isSupplement.value || isRedApplyMode.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          (isSupplement.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                _createTextVNode(" 原上传 "),
                _createElementVNode("b", null, _toDisplayString(originBlueCount.value), 1),
                _createTextVNode(" 张 + 本次新增 "),
                _createElementVNode("b", _hoisted_54, _toDisplayString(newBlueCount.value), 1),
                _createTextVNode(" 张 ")
              ]))
            : (isRedApplyMode.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                  _createTextVNode(" 本次冲红 "),
                  _createElementVNode("b", null, "¥" + _toDisplayString((redAmount.value || 0).toFixed(2)), 1),
                  _createTextVNode(" / 原票面金额合计 "),
                  _createElementVNode("b", null, "¥" + _toDisplayString(totalBlueAmountYuan.value), 1)
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})